import type {
  ChangelogCategoryDef,
  ChangelogDraftRow,
  ChangelogScheduledRow,
  ChangelogVersionRow,
} from '@/components/painel/changelog/changelog-types';

export const CHANGELOG_PRODUCTS = [
  'xat Ajuda',
  'xat Chat',
  'xat Web',
  'xat Live',
  'xat Mobile',
  'Powers',
  'Store',
] as const;

export const MOCK_CHANGELOG_STATS = {
  totalVersions: 42,
  published: 36,
  drafts: 5,
  fixesThisMonth: 128,
  noveltyThisMonth: 34,
  topCategory: 'Correções de bugs',
  topCategoryPct: 31,
  versionsDelta: 8,
  publishedDelta: 3,
  draftsDelta: -1,
  fixesDelta: 12,
};

export const MOCK_VERSIONS: ChangelogVersionRow[] = [
  {
    id: 'v-168',
    version: 'v1.68',
    product: 'xat Web',
    status: 'published',
    publishDate: '2026-05-02T14:00:00.000Z',
    scheduledFor: null,
    sectionsCount: 6,
    author: 'equipe xat',
    title: 'Grande atualização visual do xat Web',
    summary: 'Novos temas, navegação refinada e modo foco.',
    featured: true,
  },
  {
    id: 'v-167',
    version: 'v1.67',
    product: 'xat Chat',
    status: 'published',
    publishDate: '2026-04-28T10:30:00.000Z',
    scheduledFor: null,
    sectionsCount: 4,
    author: 'Miguel',
    title: 'Melhorias de estabilidade no chat',
    summary: 'Pools de conexão e correções de smilies.',
  },
  {
    id: 'v-169-draft',
    version: 'v1.69-beta',
    product: 'Powers',
    status: 'draft',
    publishDate: null,
    scheduledFor: null,
    sectionsCount: 3,
    author: 'Ana',
    title: 'Pacote primavera & efeitos temporários',
    summary: 'Planejado para revisão de segurança antes do publish.',
  },
  {
    id: 'v-live-01',
    version: 'live-0.9.4',
    product: 'xat Live',
    status: 'scheduled',
    publishDate: null,
    scheduledFor: '2026-05-12T18:00:00.000Z',
    sectionsCount: 5,
    author: 'Bruno',
    title: 'Painel de hosts e moderação rápida',
    summary: 'Lançamento sincronizado com anúncio no blog.',
    featured: false,
  },
  {
    id: 'v-mobile-220',
    version: 'mobile-2.20',
    product: 'xat Mobile',
    status: 'published',
    publishDate: '2026-04-15T09:00:00.000Z',
    scheduledFor: null,
    sectionsCount: 7,
    author: 'Lucas',
    title: 'Gestos 2.0 e notificações agrupadas',
    summary: '',
  },
  {
    id: 'v-store-55',
    version: 'store-5.5',
    product: 'Store',
    status: 'draft',
    publishDate: null,
    scheduledFor: null,
    sectionsCount: 2,
    author: 'Julia',
    title: 'Bundles de xats e cupons sazonais',
    summary: 'Rascunho do copy comercial.',
  },
];

export const MOCK_CATEGORIES: ChangelogCategoryDef[] = [
  {
    id: '1',
    label: 'Novidades',
    icon: 'Sparkles',
    emoji: '✨',
    description: 'Lançamentos e recursos novos.',
    color: '#38bdf8',
    order: 0,
  },
  {
    id: '2',
    label: 'Melhorias',
    icon: 'Flame',
    emoji: '🔥',
    description: 'Refinos e qualidade de vida.',
    color: '#f97316',
    order: 1,
  },
  {
    id: '3',
    label: 'Correções de bugs',
    icon: 'Wrench',
    emoji: '🛠',
    description: 'Fixes e regressões.',
    color: '#a78bfa',
    order: 2,
  },
  {
    id: '4',
    label: 'UI/UX',
    icon: 'Palette',
    emoji: '🎨',
    description: 'Interface e experiência.',
    color: '#ec4899',
    order: 3,
  },
  {
    id: '5',
    label: 'Performance',
    icon: 'Zap',
    emoji: '⚡',
    description: 'Latência e otimização.',
    color: '#22d3ee',
    order: 4,
  },
  {
    id: '6',
    label: 'Segurança',
    icon: 'ShieldCheck',
    emoji: '🔒',
    description: 'Patches e políticas.',
    color: '#34d399',
    order: 5,
  },
  {
    id: '7',
    label: 'Mobile',
    icon: 'Smartphone',
    emoji: '📱',
    description: 'Apps móveis.',
    color: '#818cf8',
    order: 6,
  },
  {
    id: '8',
    label: 'Chat',
    icon: 'MessageSquare',
    emoji: '💬',
    description: 'Mensagens e salas.',
    color: '#2dd4bf',
    order: 7,
  },
  {
    id: '9',
    label: 'Web',
    icon: 'Globe',
    emoji: '🌐',
    description: 'Site e SPA.',
    color: '#60a5fa',
    order: 8,
  },
  {
    id: '10',
    label: 'Powers',
    icon: 'Gift',
    emoji: '🎁',
    description: 'Powers e loja relacionada.',
    color: '#eab308',
    order: 9,
  },
  {
    id: '11',
    label: 'Aces',
    icon: 'Ace',
    emoji: '⚔️',
    description: 'Assinaturas Ace e benefícios.',
    color: '#f59e0b',
    order: 10,
  },
];

export const MOCK_DRAFTS: ChangelogDraftRow[] = [
  {
    id: 'd1',
    version: 'v1.69',
    title: 'Novo sistema de relatórios no chat',
    lastEdited: '2026-05-06T11:42:00.000Z',
    author: 'Ana',
    authorAvatar: 'A',
    autosaved: true,
  },
  {
    id: 'd2',
    version: 'store-5.6',
    title: 'Campanha de verão · preview',
    lastEdited: '2026-05-05T19:03:00.000Z',
    author: 'Julia',
    authorAvatar: 'J',
    autosaved: false,
  },
];

export const MOCK_SCHEDULED: ChangelogScheduledRow[] = [
  {
    id: 's1',
    version: 'live-0.9.4',
    title: 'Painel de hosts e moderação rápida',
    scheduledFor: '2026-05-12T18:00:00.000Z',
    product: 'xat Live',
    steps: [
      { label: 'QA interno', done: true },
      { label: 'Copy final', done: true },
      { label: 'Anúncio blog', done: false },
      { label: 'Publicação', done: false },
    ],
  },
  {
    id: 's2',
    version: 'v1.70',
    title: 'Infra CDN · fase 1',
    scheduledFor: '2026-05-18T09:30:00.000Z',
    product: 'xat Web',
    steps: [
      { label: 'Canary', done: true },
      { label: 'Rollout global', done: false },
    ],
  },
];

export const MOCK_CHANGELOG_ANALYTICS = {
  topReleaseViews: 'v1.68 — Web visual',
  topCategoryViews: 'UI/UX',
  ctrBanners: 4.2,
  engagementScore: 78,
  spikeMonth: 'Abr/26',
  activeProduct: 'xat Web',
  seriesViews: [
    { m: 'Jan', v: 12000 },
    { m: 'Fev', v: 13200 },
    { m: 'Mar', v: 11800 },
    { m: 'Abr', v: 18900 },
    { m: 'Mai', v: 16400 },
  ],
  byProduct: [
    { name: 'xat Web', v: 38 },
    { name: 'xat Chat', v: 24 },
    { name: 'Mobile', v: 18 },
    { name: 'Outros', v: 20 },
  ],
  timeline: [
    { t: '02 mai', e: 'v1.68 publicado', k: 'release' },
    { t: '28 abr', e: 'Pico +22% após patch chat', k: 'spike' },
    { t: '20 abr', e: 'Banner CTR recorde (4,8%)', k: 'ctr' },
  ],
};
